import { inject } from '@angular/core';
import type { CreateQueryOptions } from '@tanstack/angular-query-experimental';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { PaymentMethodsApiService } from '../api/payment-methods-api.service';
import type { PaymentMethod } from '../contracts/payment-method.contract';
import { filterActiveSupportedPaymentMethods } from '../helpers/payment-methods.derived';

export const PAYMENT_METHODS_QUERY_KEY = ['payment-methods', 'active'] as const;

type PaymentMethodsQueryOverrides = Partial<Omit<CreateQueryOptions<PaymentMethod[]>, 'queryKey' | 'queryFn'>>;

export function injectPaymentMethodsQuery(optionsFn?: () => PaymentMethodsQueryOverrides) {
    const api = inject(PaymentMethodsApiService);

    return injectQuery(() => ({
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 5 * 60 * 1000,
        queryKey: PAYMENT_METHODS_QUERY_KEY,
        queryFn: async (): Promise<PaymentMethod[]> => {
            const paymentMethods = await lastValueFrom(api.getPaymentMethods());
            return filterActiveSupportedPaymentMethods(paymentMethods);
        },
        ...optionsFn?.(),
    }));
}
